import React, { createContext, useContext } from 'react';

import { isUndefined } from 'lodash';
import { Brand, Union } from './themes.types';

type BrandContextValue = {
  brand: Brand;
  setBrand: React.Dispatch<React.SetStateAction<Brand>>;
  union: Union;
  setUnion: React.Dispatch<React.SetStateAction<Union>>;
};

export const BrandContext = createContext<BrandContextValue | undefined>(
  undefined,
);

export const useBrandContext = (): BrandContextValue => {
  const context = useContext(BrandContext);

  if (isUndefined(context)) {
    throw new Error(
      'useBrandContext cannot be used outside BrandContextProvider!',
    );
  }

  return context;
};
